import axios from 'axios';
import { API } from '../../../config/api';

const http = axios.create({
  baseURL: API.BACKEND,
  timeout: 10000
});

http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export async function fetchOperators(params = {}) {
  const { data } = await http.get('/api/v1/operators', { params });
  return data;
}

export async function fetchOperator(id) {
  const { data } = await http.get(`/api/v1/operators/${id}`);
  return data;
}

export async function createOperator(payload) {
  const { data } = await http.post('/api/v1/operators', payload);
  return data;
}

export async function updateOperator({ id, ...payload }) {
  const { data } = await http.patch(`/api/v1/operators/${id}`, payload);
  return data;
}

export async function deleteOperator(id) {
  const { data } = await http.delete(`/api/v1/operators/${id}`);
  return data;
}
